import type { ClientSystemLocale } from "../../types/experiment";
import { TagInput } from "../Shared/TagInput";

interface Props {
  value: ClientSystemLocale;
  onChange: (value: ClientSystemLocale) => void;
}

export function ClientSystemLocaleFilter({ value, onChange }: Props) {
  return (
    <TagInput
      label="Locales"
      tags={value.locales}
      onChange={(locales) => onChange({ ...value, locales })}
      placeholder="e.g. en-US"
    />
  );
}
